import { initSubRoutes } from '../../../../utils/router';

const RoutesDemandeArmeTrouvee = initSubRoutes({
    route: '/demande-arme-trouvee',
    subroutes: {},
    nom: "Faire une demande d'arme trouvee",
});

export default RoutesDemandeArmeTrouvee;
